angular.module('picmonicpublic').controller('efficientEffectiveController', ['$scope', '$interval', function($scope, $interval){
    $scope.$parent.seen.efficienteffective = 1;

    $scope.selectedTweet = 0;

    var interval = $interval(function(){
        $scope.scrollTweets(1);
    }, 5000);

    this.$onDestroy = function(){
        $interval.cancel(interval);
    };

    $scope.scrollTweets = function(scroll) {
        $scope.selectedTweet = ($scope.selectedTweet + scroll + 6) % 6;
  };
}]);